import { render } from "./About.vue?vue&type=template&id=9c67b14e"
const script = {}
script.render = render

export default script